import { defineMessages } from 'react-intl'

const scope = `procurify.budgets.hooks.useFormatBudgetCustomFieldName`

export default defineMessages({
  inactiveCustomFieldLabel: {
    id: `${scope}.inactiveCustomFieldLabel`,
    defaultMessage: '{name} (inactive)',
  },
})
